module.exports = __webpack_public_path__ + "public/adminIcons/dlt.png?b362cae0";


//////////////////
// WEBPACK FOOTER
// ./public/adminIcons/dlt.png
// module id = 108
// module chunks = 8